module.exports = __webpack_public_path__ + "img/Lot15.7ff17ab0.jpg";